import { useContext } from 'react'

import { Form } from 'components/ui/form/Form'
import { tokenValidation } from 'util/validations'
import { useCreateToken } from 'hooks/mutations'
import { UserPlusIcon } from '@heroicons/react/24/outline'
import { ModalContext } from 'context/ModalContext'
import TokenForm from './TokenForm'
import { Card } from 'components/gsys-ui'

const CreateTokenModal = ({ initial }) => {
  const modal = useContext(ModalContext)
  const mutation = useCreateToken()

  return (
    <Card className="m-auto">
      <Card.Title Icon={UserPlusIcon}>Create a token</Card.Title>
      <Card.Body>
        <Form
          validation={tokenValidation}
          initial={initial}
          mutation={mutation}
          FormComp={TokenForm}
          onSubmit={modal.close}
        />
      </Card.Body>
    </Card>
  )
}

export default CreateTokenModal